const _temp0 = require("./Insignia_328129.webp");
const _temp1 = require("./Insignia_4.webp");
const _temp2 = require("./Insignia_5.webp");
const _temp3 = require("./main.webp");
module.exports = {
  "Insignia_328129": _temp0,
  "Insignia_4": _temp1,
  "Insignia_5": _temp2,
  "main": _temp3
}